/**
 * Add to cart button component
 *
 * @module component-addtocart
 * @version 1.0.0
 * @extends HTMLElement
 */

customElements.component = "addtocart-button";

if (!customElements.get(customElements.component)) {
  class addToCartButton extends HTMLElement {
    /**
     * Add to cart button web component.
     *
     * @constructor
     */
    constructor() {
      super();

      if (this.dataset.handle) {
        window.theme.product
          .loadProduct(this.dataset.handle)
          .then((product) => {
            this.product = product;

            this.render();

            this.initEvents();
          });

        this.initialButtonText =
          this.querySelector("[data-add-to-cart-text]")?.innerHTML ||
          "Add to Cart";
      } else {
        console.log("Missing product handle", this);
      }

      window.addEventListener("screen-breakpoint", (event) => {
        this.render();
      });
    }

    /**
     * Render component.
     *
     * @returns {undefined}
     */
    render() {
      this.updateAvailability(this.product.available);
      this.updateVariantSelected(false);
    }

    /**
     * Init component.
     *
     * @returns {undefined}
     */
    initEvents() {}

    /**
     * Update component data by variant id.
     *
     * @param {integer} variantId Variant id.
     * @returns {undefined}
     */
    update(variantId) {
      let variant = window.theme.product.getVariant(variantId, this.product);

      if (variant) {
        this.updateAvailability(variant.available);
        this.updateVariantSelected(true);
      }
    }

    /**
     * Update the button color depending on variant selected status
     *
     * @param {boolean} selected Selected status.
     * @returns {undefined}
     */
    updateVariantSelected(selected) {
      const btn = this.getSubmitButton();

      if (!btn) {
        return;
      }

      // if there aren't any options return
      const hasOptions =
        this.closest("component-addtocart").querySelectorAll("[data-option]")
          .length > 0;

      if (!hasOptions) {
        return;
      }

      // if there are options check if a variant has been selected
      if (selected) {
        btn.classList.remove("disabled");
      } else {
        btn.classList.add("disabled");
      }
    }

    /**
     * Render component.
     *
     * @returns {HTMLButtonElement | null}
     */
    getSubmitButton() {
      return this.querySelector('button[type="submit"]');
    }

    /**
     * Disable component.
     *
     * @returns {undefined}
     */

    disable() {
      let btn = this.getSubmitButton();
      let input = this.querySelector('input[name="quantity"]');

      if (btn) {
        btn.disabled = true;
        const addToCart = btn.querySelector(".btn-addToCart");
        const icon = btn.querySelector("[data-add-to-cart-icon]");
        if (addToCart) {
          addToCart.innerText = "Sold Out";
        }
        if (icon) {
          icon.classList.add("hidden");
        }
        if (input) {
          input.disabled = true;
        }
      }
    }

    /**
     * Enable component.
     *
     * @returns {undefined}
     */

    enable() {
      let btn = this.getSubmitButton();
      let input = this.querySelector('input[name="quantity"]');

      if (btn) {
        btn.disabled = false;
        const addToCart = btn.querySelector(".btn-addToCart");
        const icon = btn.querySelector("[data-add-to-cart-icon]");

        if (addToCart) {
          addToCart.innerHTML = this.initialButtonText;
        }
        if (icon) {
          icon.classList.remove("hidden");
        }
        if (input) {
          input.disabled = false;
        }
      }
    }

    /**
     * Init loading component status.
     *
     * @returns {undefined}
     */
    loading() {
      let btn = this.getSubmitButton();

      if (btn) {
        btn.disabled = true;
        btn.innerText = "Loading...";
      }
    }

    /**
     * Update component availability status.
     *
     * @returns {undefined}
     */
    updateAvailability(isAvailable) {
      const product_description = document.querySelector(
        ".product-single__details"
      );
      if (!product_description) {
        return;
      }
      if (isAvailable) {
        this.enable();
        product_description.classList.remove("out-stock");
      } else {
        this.disable();
        product_description.classList.add("out-stock");
      }
    }
  }

  customElements.define(customElements.component, addToCartButton);
}
